import React from "react";
import RingLoader from "../RingLoader";

import "./SuspenseLoader.scss";

const suspenseLoader = (props) => (
  <div className="suspense">
    <RingLoader size={"120px"} />
  </div>
);

export default suspenseLoader;
